export const medicalRequestsProps = {
  basename: "/plataforma/pedidos-medicos",
};
